/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueTeam } from './LeagueTeam';
import {
    LeagueTeamFromJSON,
    LeagueTeamFromJSONTyped,
    LeagueTeamToJSON,
    LeagueTeamToJSONTyped,
} from './LeagueTeam';

/**
 * 
 * @export
 * @interface RegisterTeamResponse
 */
export interface RegisterTeamResponse {
    /**
     * 
     * @type {LeagueTeam}
     * @memberof RegisterTeamResponse
     */
    team: LeagueTeam;
    /**
     * 
     * @type {string}
     * @memberof RegisterTeamResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the RegisterTeamResponse interface.
 */
export function instanceOfRegisterTeamResponse(value: object): value is RegisterTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function RegisterTeamResponseFromJSON(json: any): RegisterTeamResponse {
    return RegisterTeamResponseFromJSONTyped(json, false);
}

export function RegisterTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': LeagueTeamFromJSON(json['team']),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function RegisterTeamResponseToJSON(json: any): RegisterTeamResponse {
    return RegisterTeamResponseToJSONTyped(json, false);
}

export function RegisterTeamResponseToJSONTyped(value?: RegisterTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': LeagueTeamToJSON(value['team']),
        'message': value['message'],
    };
}

